<script setup lang="ts">
import type { VariantProps } from 'class-variance-authority'
import { badgeVariants } from '.'
import { cn } from '@/lib/utils'
import { X } from 'lucide-vue-next'

interface BadgeVariantProps extends VariantProps<typeof badgeVariants> {}

interface Props {
  variant?: BadgeVariantProps['variant']
  closeable?: boolean
}
defineProps<Props>()
</script>

<template>
  <div :class="cn(badgeVariants({ variant }), $attrs.class ?? '')">
    <slot />
    <div v-if="closeable" @click="$emit('close')" class="ml-1 cursor-pointer opacity-60">
      <X class="w-4 h-4" />
    </div>
  </div>
</template>
